import React from 'react';
export var SessionClockIcon = function SessionClockIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 28 28"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5ZM0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14Z",
    fill: "#AA9B8C"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.5C14.8284 5.5 15.5 6.17157 15.5 7V12.5H21C21.8284 12.5 22.5 13.1716 22.5 14C22.5 14.8284 21.8284 15.5 21 15.5H14C13.1716 15.5 12.5 14.8284 12.5 14V7C12.5 6.17157 13.1716 5.5 14 5.5Z",
    fill: "#AA9B8C"
  }));
};